// @flow
import type { ActionsState } from '~/core/state/actions/types';
import type { ConnectProps } from './types';

import { connect } from 'react-redux';
import generalIcons from '~/core/constants/icons/general-svg';
import { DEFAULT_TEMPLATE, actionTypes, getAttributeDefinition } from '~/core/constants/actions';
import { loadForm } from '~/core/state/actions/actions';
import { getIconLocaleSuffix } from '~/core/state/config/selectors';
import { getActionsBeingDeleted, initialiseFormFromAction } from '~/core/state/actions/selectors';
import Component from './component';

const mapStateToProps = (state: { actions: ActionsState }, { action }: ConnectProps) => {
    const actionsBeingDeleted = getActionsBeingDeleted(state);
    const region = getIconLocaleSuffix(state);
    const { id: actionId } = action;
    const formAction = initialiseFormFromAction(state, { actionId });
    if (!formAction) {
        return { formAction };
    }
    const attributes = ['when', 'while', 'then'].reduce(
        (acc, group) => ({
            ...acc,
            [group]: formAction[group].reduce((groupAttributes, event) => {
                const attr = getAttributeDefinition(event.type, region);
                return attr.type ? [...groupAttributes, { ...attr, type: event.type }] : groupAttributes;
            }, [])
        }),
        {}
    );
    const thenTypes = attributes.then.reduce(
        (acc, { type }) => (type && acc.includes(type) ? acc : [...acc, type]),
        []
    );

    return {
        actionBeingDeleted: actionsBeingDeleted.includes(actionId),
        formAction,
        icons: {
            when: attributes.when.length ? attributes.when[0].icon : generalIcons.QUESTION,
            ...(attributes.while.length ? { while: attributes.while[0].icon } : {}),
            ...(attributes.then.length
                ? {
                      then: {
                          type: thenTypes.length > 1 ? actionTypes.MIXED : attributes.then[0].icon,
                          count: attributes.then.length
                      }
                  }
                : {})
        }
    };
};

const mapDispatchToProps = {
    loadForm
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { formAction, ...restStateProps } = stateProps;
    const { loadForm } = dispatchProps;
    const { removeAction } = ownProps;

    return {
        ...restStateProps,
        ...ownProps,
        chooseAction: () =>
            formAction && formAction.template.id === DEFAULT_TEMPLATE ? removeAction(true) : loadForm(formAction)
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Component);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/my-actions/action/index.js